module.exports = __webpack_public_path__ + "static/img/banner.7f2730f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner.png
// module id = 7E6U
// module chunks = 2